import React from 'react'
import { TeamMembers, Field, Spacer } from './'
import { COLLABORATOR_GRID } from '../../../../lib/constants'

const links = {
	"Mailchimp": "https://mailchimp.com/",
	"Kin": "https://workwithkin.com",
	"School": "https://schoooool.com/"
};

const CollaboratorListItem = ({ data, last, hovered, setHovered }) => {
	return (

		<div
			className='collaborator'
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<div className='company'>
				<Field bold sanSerif className='field-company'><a href={links[data.company]} target="_blank">{data.company}</a></Field>
			</div>
			<div className="role">
				<Field longForm sanSerif className='field-role'>{data.role}</Field>
			</div>
			<Spacer />
			<div className='team'>
				<TeamMembers {...data} />
			</div>
			
			<style jsx>{`
				.collaborator {
					display: grid;
					grid-template-columns: ${COLLABORATOR_GRID};
					width: 100%;
					padding: 1.25rem 0;

					border-bottom: ${last ? 0 : '1px solid black'};
					padding-bottom: 3rem;
					position: relative;
				}
				a {
					color: black;
				}

				@media (max-width: 768px), (pointer: coarse) {
					.collaborator {
						display: block;
						padding: 1.25rem 0;
					}

					.company {
						margin-bottom: 15px;
					}
					.role {
						margin-bottom: 30px;
					}
					.company :global(.field-company) {
						font-size: 26px;
					}
					.role :global(.field-role) {
						font-size: 20px;
					}

					.tops :global(.topic) {
						margin-bottom: 10px;
					}

				}
			`}</style>
		</div>
	)
}

export default CollaboratorListItem
